module.exports = __webpack_public_path__ + "static/media/content-point.f03145f3.svg";